import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { InvoiceIntegrationModel } from '~/models/InvoiceIntegrationModel';
export const useUpdatePayoutInvoiceIntegrationCache = ()=>{
    const queryClient = useQueryClient();
    return useCallback((payload)=>{
        queryClient.setQueryData([
            QueryKeys.PayoutInvoices,
            payload.payoutId
        ], (prev)=>prev === null || prev === void 0 ? void 0 : prev.map((inv)=>inv.id === payload.invoiceId ? _object_spread_props(_object_spread({}, inv), {
                    integrations: InvoiceIntegrationModel.fromAccountingDTO(payload.invoiceIntegrations, inv.totalAmount.isZero())
                }) : inv));
    }, [
        queryClient
    ]);
};
